import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listPremiums, validatePremiums } from "../api/premium-api";
import { changeGroupPremium } from "@/features/orders/api/item-group-api";

export type PremiumTypeSlug =
  | "door_style"
  | "wood_species"
  | "finish_option"
  | "finished_side"
  | "drawer_style";

export function usePremiums(
  type: PremiumTypeSlug,
  params: Record<string, unknown>,
  enabled = true,
) {
  return useQuery({
    queryKey: ["premiums", type, params],
    queryFn: () => listPremiums(type, params),
    enabled,
  });
}

export function useValidatePremiums() {
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) =>
      validatePremiums(payload),
  });
}

export function useChangeGroupPremium(orderId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      groupId,
      payload,
    }: {
      groupId: number;
      payload: Record<string, unknown>;
    }) => changeGroupPremium(groupId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["order", orderId] }),
  });
}
